module.exports = __webpack_public_path__ + "static/media/email.6eb0e939.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/email.png
// module id = 1735
// module chunks = 1